import React from 'react'
import Nav from '../nav/Nav'

function About() {
  return (
    <>
      <div>
  <div className="sub-banner-section-outer position-relative">
    <header>
      <Nav />
    </header>
    {/* SUB-BANNER SECTION */}
    <section className="banner-section position-relative">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="banner-section-content">
              <h1 className="text-white" >About Us</h1>
              {/* <p class="text-white" data-aos="fade-right">About Our Story</p> */}
              <div className="btn_wrapper" >
                <span> Home </span><i className="fa-solid fa-angles-right" aria-hidden="true" /><span className="sub_span">About</span>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="banner_image position-relative">
              <figure className="banner_main_image mb-0 left_right_shape">
                <img src="./assets/images/about_banner_image.jpg" alt />
              </figure>
              <figure className="banner_image_bottom_shape mb-0 position-absolute top_bottom_shape">
                <img src="./assets/images/sub_banner_image_bottom_shape.png" alt className="img-fluid" />
              </figure>
            </div>
          </div>
        </div>
      </div>
    </section>
    <figure className="banner_top_shape mb-0 position-absolute top_bottom_shape">
      <img src="./assets/images/sub_banner_top_shape.png" alt className="img-fluid" />
    </figure>
    <figure className="banner_background_shape mb-0 position-absolute left_right_shape">
      <img src="./assets/images/sub_banner_background_shape.png" alt />
    </figure>
  </div>
  {/* ABOUT US SECTION */}
  <section className="about_aboutus_section position-relative">
    <div className="container">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
          <div className="aboutus_content" >
            <h6>About Us</h6>
            <h2>GazTecForge Technology Inc.</h2>
            <p>
              GazTecForge is a pioneering Research and Development company established with a passion for innovation and a commitment to excellence, we have become a driving force in the world of technology. We lead the charge in revolutionizing Artificial Intelligence, Identity Management &amp; Secure Government Document, Internet of Things, Simulators, and Communication Intelligence, ensuring that our solutions are at the forefront of technological advancement. Our journey began with a vision to propel the US and the global community into the future, crafting solutions that enable a more secure, connected, and efficient world. Today, we continue to uphold our mission of pushing the boundaries of what’s possible. We stand as a testament to the spirit of innovation, driving the research and development that transforms industries and empowers organizations to thrive in an ever-evolving digital landscape.
            </p>
            <div className="position-relative">
              <a href="http://youtu.be/Cx5aNwnZYDc.mp4" target="_blank">
                <figure className="video_fig mb-0">
                  <img className="thumb img-fluid" style={{cursor: 'pointer'}} src="./assets/images/about_aboutus_video_image.jpg" alt />
                </figure>
              </a>
              <figure className="about_video_background_shape mb-0 position-absolute left_right_shape">
                <img src="./assets/images/video_background_shape.png" alt className="img-fluid" />
              </figure>
            </div>
          </div>
        </div>
      </div>
      <figure className="aboutus_right_shape mb-0 position-absolute top_bottom_shape">
        {/* <img src="./assets/images/aboutus_video_right_shape.png" alt="" class="img-fluid"> */}
      </figure>
    </div>
  </section>
  {/* STATISTICS SECTION */}
  <section className="statistics_section position-relative section position-relative" id="section2">
    {/* <iframe width="100%" src="https://www.youtube.com/embed/By7_ncZ9ho4?mute=1&autoplay=1" frameborder="0"

      allow="accelerometer; autoplay;  clipboard-write; encrypted-media; gyroscope; picture-in-picture"

      allowfullscreen></iframe> */}
    <div className="dcc-overlay" />
    <div className="container align-items-center h-100">
      <div className="row position-relative" style={{zIndex: 1000}}>{/*  */}
        <div className="col-12">
          <div className="statistics_content mb-5 mt-0 pt-0 text-white" >
            <h3 className="mb-2">
              GazTecForge - A Pioneering Research and Development Company
            </h3>
            <p>
              GazTecForge takes pride in being one of the first Research and Development companies in the US for AI and ML. With our in-house team based in the US, we perform the entire life cycle of your projects right here in the
              the US, from inception to
              design and commissioning. This allows us to deliver innovative solutions that are both
              locally relevant and globally
              competitive.
            </p>
          </div>
        </div>
      </div>
      <figure className="statistics_left_shape mb-0 position-absolute top_bottom_shape">
        <img src="./assets/images/statistics_left_shape.png" alt className="img-fluid" />
      </figure>
      <figure className="statistics_right_shape mb-0 position-absolute top_bottom_shape">
        <img src="./assets/images/statistics_right_shape.png" alt className="img-fluid" />
      </figure>
    </div>
  </section>
  {/* MISSION VISION SECTION */}
  <section className="mission_vision_section position-relative">
    <div className="container">
      <div className="row position-relative" >
        <div className="col-lg-6 col-md-6 col-sm-6 col-12">
          <div className="mission_vision_box hover-effect">
            <figure>
              <img src="./assets/images/our_mission_image.png" alt className="img-fluid hover-effect" />
            </figure>
            <h4>Our Mission</h4>
            <p className="mb-0">
              Our mission is to design, develop, and deliver cutting-edge technology solutions that enhance operational
              efficiency, safety, and innovation. We are dedicated to supporting our clients and partners in achieving their
              objectives.
            </p>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-6 col-12">
          <div className="mission_vision_box hover-effect">
            <figure>
              <img src="./assets/images/our_vision_image.png" alt className="img-fluid hover-effect" />
            </figure>
            <h4>Our Vision</h4>
            <p className="mb-0">
              With a clear vision, we aspire to be at the forefront of technological advancement, creating solutions that empower
              organizations and government agencies for a better, secure, and connected future.
            </p>
          </div>
        </div>
        <figure className="mission_vision_background_shape mb-0 position-absolute left_right_shape">
          <img src="./assets/images/mission_vision_background_shape.png" alt className="img-fluid" />
        </figure>
      </div>
      <figure className="mission_vision_left_shape mb-0 position-absolute top_bottom_shape">
        <img src="./assets/images/mission_vision_left_shape.png" alt className="img-fluid" />
      </figure>
    </div>
  </section>
  {/* FEATURES SECTION */}
  <section className="feature_section position-relative">
    <div className="container">
      <div className="row">
        <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
          <div className="feature_image">
            <figure className="feature_main_image position-relative mb-0">
              <img src="./assets/images/feature_image1.jpg" alt className="img-fluid" />
            </figure>
            <figure className="feature_second_image position-absolute mb-0">
              <img src="./assets/images/feature_image2.jpg" alt className="img-fluid" />
            </figure>
          </div>
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
          <div className="feature_content" >
            <h2>Our Core Values</h2>
            <ul className="list-unstyled mb-0">
              <li className="d-block d-lg-flex">
                <figure className="mb-0">
                  <img src="./assets/images/innovation.png" alt className="img-fluid" />
                </figure>
                <div className="feature_content_wrapper">
                  <p className="first_p">Innovation</p>
                  <p className="text-size-16 mb-0">
                    We foster a culture of innovation, continuously seeking new ways to solve complex challenges.
                  </p>
                </div>
              </li>
              <li className="second_li d-block d-lg-flex">
                <figure className="mb-0">
                  <img src="./assets/images/integration.png" alt className="img-fluid" />
                </figure>
                <div className="feature_content_wrapper">
                  <p className="first_p">Integrity</p>
                  <p className="text-size-16 mb-0">
                    We operate with the utmost integrity, ensuring the highest standards of ethics in all we do.
                  </p>
                </div>
              </li>
              <li className="second_li d-block d-lg-flex">
                <figure className="mb-0">
                  <img src="./assets/images/collaborate.png" alt className="img-fluid" />
                </figure>
                <div className="feature_content_wrapper">
                  <p className="first_p">Collaboration</p>
                  <p className="text-size-16 mb-0">
                    Collaboration is at the heart of our approach. We work closely with our clients and partners to co-create solutions that bring value.
                  </p>
                </div>
              </li>
              <li className="second_li d-block d-lg-flex">
                <figure className="mb-0">
                  <img src="./assets/images/quality.png" alt className="img-fluid" />
                </figure>
                <div className="feature_content_wrapper">
                  <p className="first_p">Quality</p>
                  <p className="text-size-16 mb-0">
                    We are unwavering in our commitment to deliver quality solutions, setting the highest standards for our work.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <figure className="feature_background_shape mb-0 position-absolute left_right_shape">
        {/* <img src="./assets/images/features_background_shape.jpg" alt=""> */}
      </figure>
      <figure className="feature_top_shape mb-0 position-absolute top_bottom_shape">
        <img src="./assets/images/features_top_shape.png" alt className="img-fluid" />
      </figure>
    </div>
  </section>
  {/* COMBO SECTION */}
  <section className="combo_section section" id="section8">
    {/* FAQ'S SECTION */}
    <div className="accordian-section">
      <div className="container">
        <div className="row">
          <div className="col-xxl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="heading position-relative text-left text-white">
              <h6>FAQ’s</h6>
              <h2 className="mb-3">Frequently Asked Questions</h2>
              <p>
                We understand that every organization is unique. That’s why we don’t offer one-size-fits-all solutions. GazTecForge takes
                the time to understand your specific requirements and crafts customized strategies that align perfectly with your
                goals.
              </p>
            </div>
          </div>
          <div className="col-12 col-xxl-6 col-lg-6 col-md-12 col-sm-12">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 mb-4" >{/**/}
                <div className="about-service-section-text accordian-section-inner-text position-relative">
                  <div className="accordian-inner">
                    <div id="accordion1">
                      <div className="accordion-card">
                        <div className="card-header" id="headingFour">
                          <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                            Advanced AI Solutions
                          </button>
                        </div>
                        <div id="collapseFour" className="collapse" aria-labelledby="headingFour">
                          <div className="card-body">
                            <p className="text-size-16 text-left mb-0 p-0">
                              Our team of experts specializes in developing advanced AI algorithms and machine learning models. We create
                              intelligent systems that can learn, adapt, and enhance your operations.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-card">
                        <div className="card-header" id="headingFive">
                          <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                            IoT for a Connected World
                          </button>
                        </div>
                        <div id="collapseFive" className="collapse" aria-labelledby="headingFive">
                          <div className="card-body">
                            <p className="text-size-16 text-left mb-0 p-0">
                              The Internet of Things is transforming how we collect and utilize data. GazTecForge 's IoT solutions provide real-time
                              insights, allowing you to make informed decisions and optimize your processes.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-card">
                        <div className="card-header" id="headingSix">
                          <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                            Simulators for Realistic Training
                          </button>
                        </div>
                        <div id="collapseSix" className="collapse" aria-labelledby="headingSix">
                          <div className="card-body">
                            <p className="text-size-16 text-left mb-0 p-0">
                              Enhance safety and readiness with our cutting-edge simulators. Whether it's first responders, defense personnel, or
                              law enforcement, our simulators offer immersive, realistic training experiences.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-card">
                        <div className="card-header" id="headingSeven">
                          <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                            Communication Intelligence
                          </button>
                        </div>
                        <div id="collapseSeven" className="collapse" aria-labelledby="headingSeven">
                          <div className="card-body">
                            <p className="text-size-16 text-left mb-0 p-0">
                              Our communication intelligence solutions are designed to ensure secure, efficient, and intelligent communication
                              across a wide range of applications.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <figure className="mb-0 faq_right_shape position-absolute top_bottom_shape">
        {/* <img src="./assets/images/faq_right_shape.png" alt="" class="img-fluid"> */}
      </figure>
    </div>
    {/* CLIENT LOGO'S SECTION */}
    {/* <div class="client_logos_section">

      <div class="container">

          <div class="showcase">

              <div class="slider clearfix">

                  <img src="./assets/images/client_logo_image1.png" alt="" class="item">

                  <img src="./assets/images/client_logo_image2.png" alt="" class="item">

                  <img src="./assets/images/client_logo_image3.png" alt="" class="item">

                  <img src="./assets/images/client_logo_image4.png" alt="" class="item">

                  <img src="./assets/images/client_logo_image5.png" alt="" class="item">

                  <img src="./assets/images/client_logo_image6.png" alt="" class="item">

                  <img src="./assets/images/client_logo_image7.png" alt="" class="item">

                  <img src="./assets/images/client_logo_image8.webp" alt="" class="item">

              </div>

          </div>

      </div>

  </div> */}
  </section>
</div>


    </>
  )
}

export default About